import { defineStore } from 'pinia';
import axios, { AxiosError } from 'axios';
import { getMerchants } from '@shared/api/api';
import { Merchant } from '../../../../shared/api/merchants';

export default defineStore('allMerchants', {
	state: () => ({
		merchantsData: {},
		divisionsData: {},
		error: false,
		errorResponse: '',
		loading: false,
	}),
	getters: {},
	actions: {
		setAllMerchants(merchantsData: Merchant[]) {
			this.merchantsData = merchantsData;
		},
		async getAllMerchants(merchantName?: string) {
			this.loading = true;
			try {
				const params = {
					limit: 25,
					query: merchantName,
				};

				const { data } = await getMerchants(params);

				if (data) this.merchantsData = data.elements;
			} catch (error) {
				this.error = true;
				if (error instanceof AxiosError && error?.response) {
					this.errorResponse = error.response.toString();
				}
			} finally {
				this.loading = false;
			}
		},
		async fetchAllDivisions(merchantCode: string) {
			this.loading = true;
			try {
				const { data } = await axios.get(
					`/accountowner/api/v2/accountowners/merchants/${merchantCode}/divisions`
				);
				if (data) this.divisionsData = data;
			} catch (error) {
				this.error = true;
			} finally {
				this.loading = false;
			}
		},
	},
});
